module.exports = __webpack_public_path__ + "img/logo.b93f873b.jpg";